// extracted by mini-css-extract-plugin
module.exports = {"filters":"x9dsIRG8"};